// extracted by mini-css-extract-plugin
export default {"listSizing":"StudentList_listSizing__1cTrg","searchWrapper":"StudentList_searchWrapper__+e7VT","studentListWrapper":"StudentList_studentListWrapper__RpolU"};